import { getInvoice } from 'actions/invoices'
import SingleInvoice from 'features/Invoice/SingleInvoice'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const DirectInvoice = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: 'ON_DIRECT_INVOICE' })
  }, [dispatch])

  const searchParams = new URLSearchParams(document.location.search)

  const token = searchParams.get('token')
  const locale = searchParams.get('locale')
  const invoiceIds = searchParams.get('invoiceIds')

  useEffect(() => {
    if (token && locale && invoiceIds) {
      dispatch({ type: 'SET_HOTEL_LOCALE', payload: locale })
      dispatch(
        getInvoice(
          invoiceIds.split(',').map(id => Number(id)),
          token
        )
      )
    }
  }, [token, locale, invoiceIds, dispatch])

  const { isLoading, error, invoiceList } = useSelector(s => s.invoices)

  return (
    <>
      {error && <span id="error">Invoice not found!</span>}
      {isLoading && <div id="ready">waiting for function execution</div>}
      {!error &&
        !isLoading &&
        invoiceIds
          .split(',')
          .map(id => Number(id))
          .map(invoiceId => (
            <SingleInvoice
              key={invoiceId}
              {...invoiceList[invoiceId]}
              invoiceId={invoiceId}
            />
          ))}
    </>
  )
}

export default DirectInvoice
